import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <span className="logo-f">S2</span>
          <span className="logo-text">Mobila</span>
        </div>

        {/* Desktop Menu */}
        <ul className="navbar-menu desktop-menu">
          <li><a href="/">Acasa</a></li>
          <li><a href="/proiecte-mobila-sector-2-bucuresti">Despre proiectele noastre</a></li>
          <li><a href="/servicii-mobila-la-comanda-sector-2">Servicii</a></li>
          {/* <li><a href="#news">News</a></li> */}
          <li><a href="/catalog-mobila-bucuresti">Catalog</a></li>
          <li><a href="/contact-mobila-sector-2-bucuresti">Contact</a></li>
        </ul>

        {/* Mobile Menu Button */}
        <div className="mobile-menu-button" onClick={toggleMenu}>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
  <ul className="mobile-menu-items">
    <li><a href="/">Acasa</a></li>
    <li><a href="/proiecte-mobila-sector-2-bucuresti">Despre proiectele noastre</a></li>
    <li><a href="/servicii-mobila-la-comanda-sector-2">Servicii</a></li>
    <li><a href="/catalog-mobila-bucuresti">Catalog</a></li>
    <li><a href="/contact-mobila-sector-2-bucuresti">Contact</a></li>
  </ul>
</div>

        {/* Mobile Menu Overlay */}
        <div 
          className={`menu-overlay ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        ></div>
      </div>
    </nav>
  );
};

export default Navbar;